import { useState } from "react";
import * as yup from "yup";

const useHandleForm = (data, createCallback, invalidDataCallback, isSocietySignActive) => {
  const createInitialData = () => {

    const getInitialFieldData = (fieldName) => {
      return data[fieldName] || "";
    }

    const fieldNames = [
      "approves",
      "comment",
      "password",
    ];

    return fieldNames.reduce((initialData, fieldName) => {
      return ({
        ...initialData,
        [fieldName]: getInitialFieldData(fieldName)
      })
    }, {});
  }

  const [formData, setFormData] = useState(createInitialData());

  const dataIsValid = async () => {
    const schema = yup.object().shape({
      "approves": yup.string().required(),
      "comment": yup.string()
        .when("approves", {
          is: (value) => value === "N",
          then: yup.string().required()
        }),
      "password": yup.string()
        .when("approves", {
          is: (value) => value === "Y" && isSocietySignActive,
          then: yup.string().required()
        }),
    });

    return await schema.isValid(formData).then((valid) => valid);
  }

  const submit = async () => {
    if (await dataIsValid()) {
      createCallback(formData);

      return true;
    } else {
      invalidDataCallback();
      return false;
    }
  }

  const setFormValue = (value, fieldName) => {
    if (fieldName === "approves") {
      setFormData({
        ...formData,
        [fieldName]: value,
        comment: "",
        password: "",
      });
      return;
    }

    setFormData({
      ...formData,
      [fieldName]: value,
    });
  }

  return {
    formData,
    setFormValue,
    submit,
  };
}

export default useHandleForm;